import { Client } from "./_clientService";

const executeRequest = async (options: any) => {
  try {
    const resp = await new Client(options)[options.method]();
    return resp;
  } catch (error) {
    throw error;
  }
};

async function listSchedules(params?: any) {
  const queryParams = new URLSearchParams();
  if (params?.operatorId) queryParams.set("operatorId", params.operatorId);
  if (params?.reportType) queryParams.set("reportType", params.reportType);
  queryParams.set("pageNo", params?.pageNo || "1");
  queryParams.set("pageSize", params?.pageSize || "25");

  return executeRequest({
    path: `/report-schedules/list?${queryParams.toString()}`,
    method: "get",
  });
}

async function getSchedule(id: string) {
  if (!id) throw new Error("No schedule id provided");

  return executeRequest({
    path: `/report-schedules/info/${id}`,
    method: "get",
  });
}

async function createSchedule(data: any) {
  return executeRequest({
    path: "/report-schedules/create",
    payload: data,
    method: "post",
  });
}

async function updateSchedule(id: string, data: any) {
  return executeRequest({
    path: `/report-schedules/update/${id}`,
    payload: data,
    method: "patch",
  });
}

async function deleteSchedule(id: string) {
  return executeRequest({
    path: `/report-schedules/delete/${id}`,
    method: "delete",
  });
}

async function toggleSchedule(id: string) {
  return executeRequest({
    path: `/report-schedules/toggle/${id}`,
    method: "patch",
  });
}

async function testSchedule(id: string, data: { email: string }) {
  return executeRequest({
    path: `/report-schedules/test/${id}`,
    payload: data,
    method: "post",
  });
}

async function getRunHistory(id: string, params?: any) {
  const queryParams = new URLSearchParams();
  if (params?.limit) queryParams.set("limit", params.limit);

  const query = queryParams.toString();
  return executeRequest({
    path: `/report-schedules/runs/${id}${query ? `?${query}` : ""}`,
    method: "get",
  });
}

async function getScheduleColumns(reportType: string) {
  return executeRequest({
    path: `/report-schedules/columns/${reportType}`,
    method: "get",
  });
}

export {
  listSchedules,
  getSchedule,
  createSchedule,
  updateSchedule,
  deleteSchedule,
  toggleSchedule,
  testSchedule,
  getRunHistory,
  getScheduleColumns,
};
